import { FeatureFlag, useFeatureFlagsContext } from '@app/contexts';
import { FeatureFlagToMatch } from '@app/constants';

export const useFeatureFlag = ({
  name,
  isActiveIfNotFound = false,
}: FeatureFlagToMatch): FeatureFlag => {
  const featureFlags = useFeatureFlagsContext();

  return (
    featureFlags.find(flag => flag.name === name) ?? {
      name,
      isActive: isActiveIfNotFound,
    }
  );
};
